import "./style.css";
import layout from "./layout.html";
import Text from "@blocks/Text";
import CustomImage from "@blocks/Image";
import Credits from "@blocks/Credits";

export default class Block7 {
  static selector = ".block-7";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.itemTemplate = this.block.querySelector("#block-7__item-template");
    this.itemsNode = this.block.querySelector(".block-7__items");

    this.attributes = attrs;
  }

  setupItem = async (element) => {
    return new Promise(async (resolve) => {
      const itemNode =
        this.itemTemplate.content.firstElementChild.cloneNode(true);
      if (itemNode) {
        const imageNode = itemNode.querySelector(".image");
        await new CustomImage(imageNode, element.image).onReady();

        const textNode = itemNode.querySelector(".text");
        await new Text(textNode, element.text).onReady();

        const creditsNode = itemNode.querySelector(".credits");
        await new Credits(creditsNode, element.credits).onReady();

        resolve(itemNode);
      } else {
        reject(false);
      }
    });
  };

  setup = async () => {
    return new Promise(async (resolve) => {
      this.attributes.forEach(async (element) => {
        const itemNode = await this.setupItem(element);
        if (itemNode) {
          this.itemsNode.appendChild(itemNode);
        }
      });
      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
